// extracted by mini-css-extract-plugin
module.exports = {"container":"_3UiiTS","section":"C8gOEP","button":"y0nHhF","male":"_3936ne","female":"EIG2w1","buttonContainer":"_3enNrw","title":"HiNZdF","picture":"_36yrgk"};